import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Card, BlockStack, SkeletonBodyText, SkeletonDisplayText, InlineGrid } from '@shopify/polaris';
import './index.css';
import { store } from '../../../redux/store';
import { on } from '@all-in-one/cross-domain';

class SolutionExpert extends Component {
    state = {
        shopify_domain: this.props.shopDomain,
        app: '518111167165693952', // 中台提供
        loading: true,
        searchPar: '',          // 参数
        dVersion: 'local',
    }

    UNSAFE_componentWillMount() {
        const locals = this.props.location;
        let searchPar = locals.search !== '' ? `&${locals.search.replace('?', '')}` : '';
        this.setState({
            searchPar,
            dVersion: process.env.REACT_APP_ARMS_ENV
        })
    }

    componentDidMount() {
        this.setDomain();
        store.subscribe(() => {
            this.setDomain();
        })
        on("all-in-one", this.openWillDesk);
    }

    setDomain = () => {
        let _store = store.getState().public;
        this.setState({
            shopify_domain: _store.shopDomain,
            email: _store.email,
        })
    }

    // 监听加载
    onloadIframe = () => {
        this.setState({
            loading: false,
        })
    }

    // 调起客服
    openWillDesk = (msg) => {
        try {
            window.Willdesk.show();
            if (msg) {
                window.Willdesk.chat(msg);
            }
        } catch (e) { }
    }

    render() {
        const {
            shopify_domain,
            app,
            loading,
            email,
            searchPar,
            dVersion,

        } = this.state;

        // 骨架屏
        const cardBox = <InlineGrid gap="400" columns={window.innerWidth < 768 ? 1 : 2}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </InlineGrid>
        const SkeltonLoadingBox = <BlockStack gap={400}>
            <SkeletonDisplayText size="small" />
            <SkeletonBodyText lines={1} />
            {cardBox}
            {cardBox}
            {cardBox}
            {cardBox}
            {cardBox}
            {cardBox}
        </BlockStack>

        // 遮罩层
        const shadeLoading = <div className='shade_box'>
            {SkeltonLoadingBox}
        </div>

        // 设置iframe
        const edEmail = btoa(email).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        const urlDomain = dVersion === 'local' ? 'https://aio-apps-test.channelwill.com' : 'https://aio-apps.channelwill.com';
        const src = `${urlDomain}/?shopify_domain=${shopify_domain}&app=${app}&email=${edEmail}&has_combo=true${searchPar}`;

        // 最终页面
        const pageContent = <div className='cw_app'>
            {loading && shadeLoading}
            <div className='solution_expert'>
                {
                    shopify_domain && <iframe
                        id="all-in-one"
                        className="h-screen w-full border-none"
                        title="recommended-apps"
                        src={src}
                        onLoad={this.onloadIframe}
                    />
                }
            </div>
        </div>;

        return pageContent;

    }
}


export default withRouter(SolutionExpert);
